export default __webpack_public_path__ + "static/Plots0010-f39265b8c149a6e42030599f4187bc35.jpg";